/* eslint-disable no-console */
import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet, useNavigation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { Box } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import { ROUTES } from '../Router';
import Loader from './loader/Loader';
import { ErrorFallback } from '../lib/ErrorFallback';
import { WebPubSubProvider } from '../contexts/WebPubSubContext';
import GAListener from './GAListener';
import NavigationLayout from './common/Layout';
import InactivityTimer from './InactivityTimer';

// Lazy-loaded layout components with named chunks for easier profiling/debugging
const SubscriptionStatus = lazy(() => import(/* webpackChunkName: "subscription-status" */ './subscription/Status'));

export default function Root() {
    const navigation = useNavigation();
    const user = useSelector((state) => state.auth.user);

    const errorBoundaryResetHandler = (details) => {
        // This is called when `resetErrorBoundary` is invoked.
        // You can do cleanup here, reset redux state etc.
        console.log('Error boundary reset', details);
    };

    const errorBoundaryErrorHandler = (error, info) => {
        // Log error to a service or console
        console.error('ErrorBoundary caught an error:', error, info);
    };

    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={errorBoundaryResetHandler}
            onError={errorBoundaryErrorHandler}
        >
            <GAListener />
            <InactivityTimer />
            {user ? (
                <WebPubSubProvider>
                    <Loader isLoading={navigation.state === 'loading'} />
                    <div className="main-layout">
                        <ToastContainer />

                        <NavigationLayout>
                            <Suspense fallback={null}>
                                <Box variant="div" sx={{ p: 4 }} className="dashboard_container">
                                    {/* Alert for subscription statuses */}
                                    <SubscriptionStatus />
                                    <Outlet />
                                </Box>
                            </Suspense>
                        </NavigationLayout>
                    </div>
                </WebPubSubProvider>
            ) : (
                <Navigate to={ROUTES.LOGIN} replace />
            )}
        </ErrorBoundary>
    );
}
